enum Commands {
  MoveLeft = "MOVE_LEFT",
  MoveRight = "MOVE_RIGHT",
  MoveDown = "MOVE_DOWN",
  RotateRight = "ROTATE_RIGHT",
  RotateLeft = "ROTATE_LEFT",
  HardDrop = "HARD_DROP",
  HoldPiece = "HOLD_PIECE",
}

export default Commands;
